<script>
import Events from "./Events/Index";
import PersonalData from "./PersonalData";
import BankAccountData from "./BankAccountData";
import AddressData from "./AddressData";

export default {
  components: {
    Events,
    PersonalData,
    BankAccountData,
    AddressData
  },

  props: {
    professional: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      bankAccount: null,
      paymentGatewayAccountId: null,
      address: null
    };
  },

  methods: {
    setPaymentGatewayAccountId() {
      const professionalPga = this.professional.account.payment_gateway_account;

      this.paymentGatewayAccountId = professionalPga
        ? professionalPga.id
        : null;
    },

    setBankAccount() {
      const professionalPga = this.professional.account.payment_gateway_account;

      if (!professionalPga) {
        this.bankAccount = null;

        return;
      }

      if (!professionalPga.bank_accounts.length) {
        this.bankAccount = {
          id: null,
          account_type: "CHECKING",
          bank_number: null,
          agency_number: null,
          agency_check_number: 0,
          account_number: null,
          account_check_number: 0
        };

        return;
      }

      this.bankAccount = professionalPga.bank_accounts[0];
    },

    setAddress() {
      const pga = this.professional.account.payment_gateway_account;

      if (!pga) {
        return;
      }

      this.address = pga.address;
    }
  },

  mounted() {
    this.setPaymentGatewayAccountId();
    this.setBankAccount();
    this.setAddress();
  }
};
</script>

<template>
  <div class="form-data" v-if="professional">
    <div class="title header">
      <div>
        {{ professional.account.first_name }}
        {{ professional.account.last_name }}
      </div>

      <div>
        <Events :events="this.professional.account.events" />
      </div>
    </div>

    <PersonalData :professional="professional" @refresh="$emit('refresh')" />

    <BankAccountData
      v-if="bankAccount"
      :bankAccount="bankAccount"
      :paymentGatewayAccountId="paymentGatewayAccountId"
    />

    <AddressData v-if="address" :address="address" />
  </div>
</template>

<style scoped>
.form-data {
  padding: 0 16px;
}

.header {
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/Professionals/Edit/FormData/Index.vue